import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import useContactPersonStore from '../../store/useContactPersonStore';
import { Button, Grid2 } from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import { designationOption } from '../marketingExecutive/ContactPersonList';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { PhoneInputFormField } from '../../shared/components/formfields/PhoneInputFormField';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import useAuthStore from '../../store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { Grid_Gap } from '../../shared/constants';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useParams } from 'react-router-dom';
import api from '../../assets/nodeApi/axiosInstance';

const CommonContactPerson = ({ ApartmentOption, isLoadingApart }) => {
    
    const { id } = useParams()
    const { token } = useAuthStore()
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const { contactperson, clearContactperson } = useContactPersonStore()
    const selectedApartment = ApartmentOption?.find(item => item.id?.toString() === (id?.toString() ?? contactperson?.apartment_id?.toString()));
  
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        mobile_no: Yup.string().test(
            "is-phone",
            "Phone number is not valid",
            (value) => value && isValidPhoneNumber(value)
        ).required("Mobile Number is required"),
        email: Yup.string().email('Invalid email').required('Email is required'),
        designation: Yup.string().required('Designation is required'),
    });
   
    const initialValues = {
        apartment_id: selectedApartment?.id || contactperson?.apartment_id || "",
        name: contactperson?.name || "",
        mobile_no: contactperson?.mobile_no || "",
        email: contactperson?.email || "",
        designation: contactperson?.designation || ""
    };
   
    const mutation = useMutation({
        mutationFn: (formData) => {
            return contactperson?.id
                ? api.put(`collab-updateContactpersonDetails/${contactperson?.id}`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                : api.post(`collab-createContactperson`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['all-collab-apartment-details'] });
            queryClient.invalidateQueries({ queryKey: ['collab-apartment-details-list'] });
            clearContactperson()
        },
        onError: (error) => {
            showToaster(error?.response?.data?.message || "Something Went wrong", 'Error', 'error')
        },
    });
   
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const obj = {
            apartment_id: selectedApartment?.id,
            contacts: [{ ...values }]
        }
        mutation.mutate(values, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }
   
    return (
        <>

            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}

            >
                {({ resetForm }) => (
                    <Form>
                        <Grid2 container spacing={Grid_Gap}>
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                <Field
                                    name="apartment_id"
                                    component={IdAutoCompleteField}
                                    options={ApartmentOption}
                                    label="Select Apartment"
                                    isRequired={true}
                                    isLoading={isLoadingApart}
                                    disabled={true}

                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                <Field
                                    name="name"
                                    component={TextFormField}
                                    label="Name"
                                    isRequired={true}

                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                <Field
                                    name="mobile_no"
                                    component={PhoneInputFormField}
                                    label="Mobile No"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                <Field
                                    name="email"
                                    component={TextFormField}
                                    label="Email"
                                    isRequired={true}

                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                <Field
                                    name="designation"
                                    component={AutoCompleteField}
                                    options={designationOption}
                                    label="Designation"
                                    isRequired={true}

                                />
                            </Grid2>
                            <CustomDivider />

                        </Grid2>
                        <CustomDivider />
                        <Grid2 container spacing={Grid_Gap}>
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                <Button fullWidth variant="outlined" onClick={() => { resetForm(); clearContactperson() }} > Clear </Button>
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                <Button fullWidth variant="contained" type="submit"> {Object.keys(contactperson).length === 0 ? "Submit" : "Update"} </Button>
                            </Grid2>
                        </Grid2>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default CommonContactPerson